import React from 'react'
import { homeSidebar } from '../../../data/data'
import HomeSidebarItem from './HomeSidebarItem'

export default function HomeSidebar() {
    return (
        <div className='pl-11'>
            <div className='uppercase font-firstFont tracking-wider  text-sm border-b border-transparentWhite pb-5'>Popular among others</div>
            {
                homeSidebar &&
                homeSidebar.map((item) => (
                    <HomeSidebarItem data={item} key={item.id} />
                ))
            }
        </div>
    )
}
